(() => {
  if (window.nativeProductNotifyReady) return;
  window.nativeProductNotifyReady = true;

  function initialize(root = document) {
    root.querySelectorAll('[data-native-pdp-notify]').forEach(host => {
      if (host.dataset.ready === 'true') return;
      const form = document.getElementById(host.dataset.formId);
      const payment = form?.querySelector('.product-form__payment-container');
      const section = host.closest('[data-section-type="product"]');
      const dialog = host.querySelector('[data-native-notify-dialog]');
      const trigger = host.querySelector('[data-native-notify]');
      if (!payment || !section || !dialog || !trigger || !window.nativeBackInStock) return;
      host.dataset.ready = 'true';
      section.classList.add('native-pdp-notify-enabled');
      payment.insertAdjacentElement('afterend', trigger);
      window.nativeBackInStock.sync(dialog, {
        id: host.dataset.variantId,
        title: host.dataset.variantTitle,
        available: host.dataset.variantAvailable
      });
      section.addEventListener('variant:changed', event => {
        if (event.target !== section) return;
        const variant = event.detail?.variant;
        if (variant) window.nativeBackInStock.sync(dialog, variant);
        else {
          trigger.hidden = true;
          if (dialog.open) dialog.close();
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
